module.exports = __webpack_public_path__ + "media/images/csr_sp-10e2aeda2a96edcec871fff0b2d5d50d.png";